import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    template:
    `
      <h1>Strona nie istnieje</h1>
      <button (click)="goToMainPage()">Wracaj</button>
    `
})
export class PageNotFoundComponent implements OnInit {

  constructor(private router: Router) { }

  public ngOnInit() {
  }

  goToMainPage() {
    this.router.navigate(['/']);
  }
}
